import styled from '@emotion/styled';

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.PrimaryActionColorPure};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const S = {
  Container,
};

export default S;
